import { Box, Typography } from '@mui/material';
import { useState } from 'react';
import ChatDialog from './ChatDialog';
import { IExpert } from '../types';
import chatbotImage from '../assets/chatbot.png';
import { useLanguage } from '../context/language.context';

interface FloatingChatButtonProps {
    profileData?: IExpert;
}

const FloatingChatButton = ({ profileData }: FloatingChatButtonProps) => {
    const [isChatOpen, setIsChatOpen] = useState(false);
    const { t } = useLanguage();

    // Determine type based on safe_space
    const userType: 'expert' | 'therapist' = profileData?.safe_space ? 'therapist' : 'expert';

    return (
        <>
            <Box
                onClick={() => setIsChatOpen(true)}
                sx={{
                    position: 'fixed',
                    bottom: 24,
                    right: 24,
                    zIndex: 1000,
                    cursor: 'pointer',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 1,
                    animation: 'bounce 2s infinite',
                    '@keyframes bounce': {
                        '0%, 100%': {
                            transform: 'translateY(0)',
                        },
                        '50%': {
                            transform: 'translateY(-10px)',
                        },
                    },
                    '&:hover': {
                        opacity: 0.8,
                        animation: 'none',
                        transform: 'scale(1.1)',
                        transition: 'transform 0.2s ease-in-out',
                    },
                }}
            >
                <img 
                    src={chatbotImage} 
                    alt="Chatbot" 
                    style={{ 
                        width: '80px', 
                        height: '80px',
                        objectFit: 'contain',
                        display: 'block',
                    }} 
                />
                <Typography
                    variant="body2"
                    sx={{
                        color: 'text.primary',
                        textAlign: 'center',
                        fontSize: '12px',
                        fontWeight: 500,
                        whiteSpace: 'pre-line',
                        lineHeight: 1.4,
                    }}
                >
                    {t('chatbotLabel')}
                </Typography>
            </Box>
            <ChatDialog 
                open={isChatOpen} 
                onClose={() => setIsChatOpen(false)} 
                userType={userType}
                instructorId={profileData?._id}
            />
        </>
    );
};

export default FloatingChatButton;
